const VERSION = '2.0.15a'
export default VERSION
